import React, {
  useState,
  useEffect,
  // useMemo,
  useCallback,
  // useRef,
} from "react";
import apiService from "../services/apiService";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { parse, format } from "date-fns";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SyncIcon from "@mui/icons-material/Sync";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Tooltip,
  Container,
  Typography,
  TextField,
  Button,
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  MenuItem,
  CssBaseline,
  Pagination,
  Menu,
  Switch,
  Autocomplete,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { TablePagination } from "@mui/material";
// import EditOutlined from "@mui/icons-material/EditOutlined";
import { ReactComponent as SettingsIcon } from "../Icons/Settings.svg";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ThemeProvider } from "@mui/material/styles";
import Table_theme from "../Themes/TableTheme";
import theme from "../Themes/FormThemes";
import { ReactComponent as StartTimeIcon } from "../Icons/Start time.svg";
import { ReactComponent as EndTimeIcon } from "../Icons/End time.svg";
import { ReactComponent as SuccessIcon } from "../Icons/Job success.svg";
import { ReactComponent as FailureIcon } from "../Icons/Job Failure.svg";
import { ReactComponent as NilIcon } from "../Icons/Job Nil.svg";
import { ReactComponent as NotesIcon } from "../Icons/Notes.svg";
import { ReactComponent as FailureReasonIcon } from "../Icons/failure_reason.svg";
import { ReactComponent as CloneIcon } from "../Icons/Clone.svg";
import { ReactComponent as FlagIcon } from "../Icons/Flag.svg";
import { ReactComponent as EditIcon } from "../Icons/Edit.svg";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";
import { ReactComponent as FailedRecoveredIcon } from "../Icons/Job failedrecovered.svg";
import JobStatusDetails from "../Components/JobMonitoringDetails";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function JobMonitoring() {
  // const [dateFilterErrors, setDateFilterErrors] = useState({});
  const [selectedParentDate, setSelectedParentDate] = useState("");
  const [jobsList, setJobsList] = useState([]);
  const [rowsPerPage] = useState(20); // fixed size, no dropdown

  const [timeError, setTimeError] = useState("");
  const getCurrentDate = () => {
    const today = new Date();
    return today.toLocaleDateString("en-CA"); // Returns "2025-12-15"
  };
  const [jobs, setJobs] = useState([]);
  const [clients, setClients] = useState([]);
  const [environments, setEnvironments] = useState([]);
  const [applications, setApplications] = useState([]);
  const [logicalGroups, setLogicalGroups] = useState([]);
  const [confirmClone, setConfirmClone] = useState({
    open: false,
    js_id: null,
  });
  const compactMultilineStyles = {
    "& .MuiInputBase-root": {
      minHeight: "80px",
      fontSize: "0.85rem",
      padding: "0 10px",
    },
    "& .MuiInputBase-input": {
      padding: "8px 10px",
      lineHeight: "1.2",
      overflowY: "auto",
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.85rem",
      top: "-2px",
    },
    "& .MuiInputLabel-shrink": {
      top: "0",
    },
    "& .MuiFormHelperText-root": {
      fontSize: "0.875rem",
    },
  };
  // ADD THESE (replace the old ones)

  const [filter, setFilter] = useState({
    env_id: "",
    app_id: "",
    job_id: "",
    job_name: "",
    lg_id: "",
    active_flag: "1",
    date_monitored_from: getCurrentDate(), // ← TODAY
    date_monitored_to: getCurrentDate(), // ← TODAY
  });

  // Cascading filter states
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [filteredLogicalGroups, setFilteredLogicalGroups] = useState([]);
  const [paginatedData, setPaginatedData] = useState({
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalRecords: 0,
      limit: 20,
      hasNext: false,
      hasPrev: false,
    },
  });

  const [filterOptions, setFilterOptions] = useState({
    environments: [],
    applications: [],
    jobIds: [],
    operations: [],
  });
  const fetchPaginatedJobs = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);

        const params = new URLSearchParams({
          page: page.toString(),
          limit: "20",
          env_id: filter.env_id || "",
          app_id: filter.app_id || "",
          job_id: filter.job_id || "",
          job_name: filter.job_name || "",
          lg_id: filter.lg_id || "",
          active_flag: filter.active_flag ?? "",
          date_monitored_from: filter.date_monitored_from || "",
          date_monitored_to: filter.date_monitored_to || "",
        }).toString();

        const result = await apiService.get(
          `/jobmonitoring/pagination?${params}`,
        );

        setPaginatedData(result);
      } catch (err) {
        setErrorMessage("Failed to load jobs");
        setTimeout(() => setErrorMessage(""), 5000);
      } finally {
        setLoading(false);
      }
    },
    [filter],
  );
  // Load filter options + first page
  useEffect(() => {
    const load = async () => {
      try {
        const opts = await apiService.get("/jobmonitoring/filter-options");
        setFilterOptions(opts);
      } catch (error) {
        console.error("Error loading filter options:", error);
      }
      fetchPaginatedJobs(1);
    };
    load();
  }, []);

  // Fetch applications when environment is selected (cascading filter)
  useEffect(() => {
    const fetchApplicationsByEnvironment = async () => {
      if (filter.env_id) {
        try {
          const appsData = await apiService.get(
            `/jobmonitoring/applications/by-environment?env_id=${filter.env_id}`,
          );
          setFilteredApplications(appsData || []);
        } catch (error) {
          console.error("Error fetching applications by environment:", error);
          setFilteredApplications([]);
        }
      } else {
        setFilteredApplications(applications);
      }
    };
    fetchApplicationsByEnvironment();
  }, [filter.env_id, applications]);

  // Fetch jobs when env_id and app_id are selected (cascading filter)
  useEffect(() => {
    const fetchJobsByContext = async () => {
      if (filter.env_id && filter.app_id) {
        try {
          const jobsData = await apiService.get(
            `/jobmonitoring/jobs/by-context?env_id=${filter.env_id}&app_id=${filter.app_id}`,
          );
          setFilteredJobs(jobsData || []);
        } catch (error) {
          console.error("Error fetching jobs by context:", error);
          setFilteredJobs([]);
        }
      } else {
        setFilteredJobs([]);
      }
    };
    fetchJobsByContext();
  }, [filter.env_id, filter.app_id]);

  // Fetch logical groups when app_id is selected (cascading filter)
  useEffect(() => {
    const fetchLogicalGroupsByApplication = async () => {
      if (filter.app_id) {
        try {
          const lgData = await apiService.get(
            `/jobmonitoring/logical-groups?app_id=${filter.app_id}`,
          );
          setFilteredLogicalGroups(lgData || []);
        } catch (error) {
          console.error("Error fetching logical groups by application:", error);
          setFilteredLogicalGroups([]);
        }
      } else {
        setFilteredLogicalGroups([]);
      }
    };
    fetchLogicalGroupsByApplication();
  }, [filter.app_id]);

  // Refetch when any filter changes
  useEffect(() => {
    fetchPaginatedJobs(1);
  }, [
    filter.env_id,
    filter.app_id,
    filter.job_id,
    filter.job_name,
    filter.lg_id,
    filter.active_flag,
    filter.date_monitored_from,
    filter.date_monitored_to,
  ]);
  const [formData, setFormData] = useState({
    cl_id: clients.length > 0 ? clients[0].cl_id : "",
    env_id: "",
    app_id: "",
    lg_id: "",
    js_id: "",
    job_id: "",
    client_job_id: "",
    scheduled_time: "",
    date_monitored: "",
    start_time: "",
    end_time: "",
    run_time: "",
    job_status: "",
    err_identified_by: "",
    comments: "",
    step_taken: "",
    active_flag: 1,
    master_file_loc: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [originalFormData, setOriginalFormData] = useState({});

  // Check if form has changed
  const hasFormChanged = () => {
    if (!isEditing) return true;
    return JSON.stringify(formData) !== JSON.stringify(originalFormData);
  };

  const [editField, setEditField] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedJsId, setSelectedJsId] = useState(null);
  const [editError, setEditError] = useState("");
  const [setCurrentPage] = useState(1);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteJsId, setDeleteJsId] = useState(null);
  // const [itemsPerPage] = useState(20);
  // const currentDate = getCurrentDate();
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [exportFilter, setExportFilter] = useState({
    from: "",
    to: "",
    app_id: "",
    env_id: "",
  });

  const validateTimes = (start, end) => {
    // If both are empty or one is empty → no error
    if (!start || !end) {
      setTimeError("");
      return true;
    }

    const startDate = new Date(start);
    const endDate = new Date(end);

    // If either is invalid format → show error
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      setTimeError("Invalid date/time format");
      return false;
    }

    // Only error if start > end
    if (startDate > endDate) {
      setTimeError("Start time cannot be later than End time");
      return false;
    }

    // All good
    setTimeError("");
    return true;
  };

  const handleCSVExport = async () => {
    if (!exportFilter.from || !exportFilter.to) {
      setErrorMessage("Please select From Date and To Date before exporting.");
      return;
    }

    if (new Date(exportFilter.from) > new Date(exportFilter.to)) {
      setErrorMessage("From Date cannot be greater than To Date.");
      return;
    }

    const params = new URLSearchParams({
      from: exportFilter.from,
      to: exportFilter.to,
      app_id: exportFilter.app_id || "",
      env_id: exportFilter.env_id || "",
    }).toString();

    try {
      const response = await fetch(
        `${BASE_URL}/jobmonitoring/exportJobMonitoringCsv?${params}`,
        {
          method: "GET",
          headers: apiService.getAuthHeaders(),
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Export failed (${response.status}): ${errorText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Job_Monitoring_${exportFilter.from}_to_${exportFilter.to}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      setOpenExportDialog(false);
    } catch (error) {
      console.error("Export error:", error);
      alert(`Failed to export: ${error.message}`);
    }
  };

  const calculateRunTime = (start, end) => {
    if (!start || !end) return "NA";
    const startDate = new Date(start);
    const endDate = new Date(end);
    if (isNaN(startDate) || isNaN(endDate)) return "NA";
    const diff = Math.max(0, endDate - startDate);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(
      seconds,
    ).padStart(2, "0")}`;
  };
  const isInvalidDateRange = () => {
    if (!exportFilter.from || !exportFilter.to) return false;

    return new Date(exportFilter.from) > new Date(exportFilter.to);
  };

  const [openStoredProcDialog, setOpenStoredProcDialog] = useState(false);
  const [storedProcDate, setStoredProcDate] = useState("");
  const [loadJobFilters, setLoadJobFilters] = useState({
    env_id: "",
    app_id: "",
  });
  const [loadJobApplications, setLoadJobApplications] = useState([]);
  const [dateExistsError, setDateExistsError] = useState("");
  const [visibleColumns, setVisibleColumns] = useState({
    client_name: false,
    environment_name: false,
    application_name: false,
    js_id: false,
    job_id: true,
    client_job_id: false,
    job_name: true,
    lg_id: true,
    frequency: true,
    master_file_loc: true,
    reference_1: true,
    scope: true,
    process_type: true,
    date_monitored: true,
    scheduled_time: true,
    start_time: true,
    end_time: true,
    run_time: true,
    job_status: true,
    err_identified_by: true,
    active_flag: true,
    comments: false,
    step_taken: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  // const [validationErrors, setValidationErrors] = useState({});
  const [disabledButtons, setDisabledButtons] = useState({});

  const columnLabels = {
    client_name: "Client",
    environment_name: "Environment",
    application_name: "Application",
    js_id: "JobMonitor ID",
    job_id: "Job ID",
    client_job_id: "Client Job ID",
    job_name: "Job Script Name",
    lg_id: "Operations",
    reference_1: "Frequency (IST)",
    scope: "Scope",
    process_type: "Process Type",
    date_monitored: "Date Monitored",
    scheduled_time: "Scheduled Time",
    start_time: "Start Time",
    end_time: "End Time",
    run_time: "Run Time",
    job_status: "Job Status",
    err_identified_by: "Recovered By",
    active_flag: "Active",
    comments: "Failure Reason",
    step_taken: "Notes",
    master_file_loc: "File Location",
  };
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  // Complete timezone-safe date utility functions
  const toDateObj = (value) => {
    if (!value) return null;
    // Strict validation for YYYY-MM-DD format
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const d = new Date(value + "T00:00:00");
    return isNaN(d.getTime()) ? null : d;
  };
  const toBeDateFormat = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };
  const toDateTimeLocal = (dbVal) =>
    dbVal ? dbVal.replace(" ", "T").slice(0, 19) : "";

  const toDateOnly = (val) => (val ? val.slice(0, 10) : "");

  // const toISO = (date) => {
  //   if (!date) return "";
  //   return date.toLocaleDateString("en-CA"); // YYYY-MM-DD
  // };

  // Format for display (MMM DD YYYY)
  const formatNiceDate = (value) => {
    if (!value) return "";
    const d = toDateObj(value);
    if (!d) return value;
    const month = d.toLocaleString("en-US", { month: "short" });
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month} ${day} ${year}`;
  };

  // Parse pasted datetime strings like "Fri Jan 9 05:15:15 CET 2026" or "Nov 26 02:25:53 PST 2025"
  const parsePastedDateTime = (input) => {
    if (!input)
      return { success: false, value: "", error: "No input provided" };

    let txt = input
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    // Pattern for "Fri Jan 9 05:15:15 CET 2026" or "Nov 26 02:25:53 PST 2025"
    const patterns = [
      // "Fri Jan 9 05:15:15 CET 2026"
      /^([A-Za-z]{3})\s+([A-Za-z]{3})\s+(\d{1,2})\s+(\d{2}):(\d{2}):(\d{2})\s+([A-Z]{2,5})\s+(\d{4})$/,
      // "Nov 26 02:25:53 PST 2025"
      /^([A-Za-z]{3})\s+(\d{1,2})\s+(\d{2}):(\d{2}):(\d{2})\s+([A-Z]{2,5})\s+(\d{4})$/,
      // "Jan 9 05:15:15 2026" (without timezone)
      /^([A-Za-z]{3})\s+(\d{1,2})\s+(\d{2}):(\d{2}):(\d{2})\s+(\d{4})$/,
      // "12/23/2025 6:30:01 PM" or "12/23/2025 18:30:01"
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)?$/i,
    ];

    let parsedDate = null;

    // Try first pattern: "Fri Jan 9 05:15:15 CET 2026"
    const match1 = txt.match(patterns[0]);
    if (match1) {
      const [_, dayName, month, day, hour, min, sec, tz, year] = match1;
      const dateStr = `${month} ${day} ${year} ${hour}:${min}:${sec}`;
      parsedDate = new Date(dateStr);
    }

    // Try second pattern: "Nov 26 02:25:53 PST 2025"
    if (!parsedDate || isNaN(parsedDate)) {
      const match2 = txt.match(patterns[1]);
      if (match2) {
        const [_, month, day, hour, min, sec, tz, year] = match2;
        const dateStr = `${month} ${day} ${year} ${hour}:${min}:${sec}`;
        parsedDate = new Date(dateStr);
      }
    }

    // Try third pattern: "Jan 9 05:15:15 2026"
    if (!parsedDate || isNaN(parsedDate)) {
      const match3 = txt.match(patterns[2]);
      if (match3) {
        const [_, month, day, hour, min, sec, year] = match3;
        const dateStr = `${month} ${day} ${year} ${hour}:${min}:${sec}`;
        parsedDate = new Date(dateStr);
      }
    }

    // Try fourth pattern: "12/23/2025 6:30:01 PM"
    if (!parsedDate || isNaN(parsedDate)) {
      const match4 = txt.match(patterns[3]);
      if (match4) {
        const [_, month, day, year, hour, min, sec, ampm] = match4;
        let hour24 = parseInt(hour);

        // Validate month and day ranges
        const monthNum = parseInt(month);
        const dayNum = parseInt(day);
        if (monthNum < 1 || monthNum > 12) {
          return {
            success: false,
            value: "",
            error: "Invalid month (must be 1-12)",
          };
        }
        if (dayNum < 1 || dayNum > 31) {
          return {
            success: false,
            value: "",
            error: "Invalid day (must be 1-31)",
          };
        }

        // Convert 12-hour to 24-hour format if AM/PM is present
        if (ampm) {
          if (ampm.toUpperCase() === "PM" && hour24 !== 12) {
            hour24 += 12;
          } else if (ampm.toUpperCase() === "AM" && hour24 === 12) {
            hour24 = 0;
          }
        }

        // Validate hour, minute, second ranges
        if (hour24 < 0 || hour24 > 23) {
          return {
            success: false,
            value: "",
            error: "Invalid hour (must be 0-23)",
          };
        }
        if (parseInt(min) < 0 || parseInt(min) > 59) {
          return {
            success: false,
            value: "",
            error: "Invalid minutes (must be 0-59)",
          };
        }
        if (parseInt(sec) < 0 || parseInt(sec) > 59) {
          return {
            success: false,
            value: "",
            error: "Invalid seconds (must be 0-59)",
          };
        }

        // Create date using MM/DD/YYYY format
        parsedDate = new Date(year, month - 1, day, hour24, min, sec);
      }
    }

    if (parsedDate && !isNaN(parsedDate)) {
      // Convert to datetime-local format: YYYY-MM-DDTHH:mm:ss
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const day = String(parsedDate.getDate()).padStart(2, "0");
      const hour = String(parsedDate.getHours()).padStart(2, "0");
      const min = String(parsedDate.getMinutes()).padStart(2, "0");
      const sec = String(parsedDate.getSeconds()).padStart(2, "0");

      return {
        success: true,
        value: `${year}-${month}-${day}T${hour}:${min}:${sec}`,
        error: null,
      };
    }

    // Return error for invalid format
    return {
      success: false,
      value: "",
      error:
        "Invalid datetime format. Supported formats: 'Fri Jan 9 05:15:15 CET 2026', 'Nov 26 02:25:53 PST 2025', 'Jan 9 05:15:15 2026', '12/23/2025 6:30:01 PM'",
    };
  };

  useEffect(() => {
    fetchJobs();
    fetchClients();
    fetchEnvironments();
    fetchApplications(); // Load all applications initially
  }, []);

  // Update client when clients are loaded and dialog is open for adding
  useEffect(() => {
    if (!isEditing && clients.length > 0 && !formData.cl_id) {
      setFormData((prev) => ({
        ...prev,
        cl_id: clients[0].cl_id,
      }));
    }
  }, [clients, isEditing, formData.cl_id]);

  // Helper function to get dynamic "Recovered by" label
  const getRecoveredByClientLabel = () => {
    const selectedClient = clients.find((c) => c.cl_id === formData.cl_id);
    if (!selectedClient) return "Recovered by Client";
    
    // Special case for Skechers (SKH) - keep original label
    if (selectedClient.cl_id === 'SKH') {
      return "Recovered by Skechers";
    }
    
    // For all other clients, use their actual name from the clients table
    return `Recovered by ${selectedClient.name}`;
  };

  const fetchJobs = async () => {
    try {
      setLoading(true);
      const data = await apiService.get("/jobmonitoring");
      setJobs(Array.isArray(data) ? data : []);
    } catch (err) {
      setErrorMessage(err.message);
      setTimeout(() => setErrorMessage(""), 3000);
      setJobs([]);
    } finally {
      setLoading(false);
    }
  };

  const uniqueEnvs = Array.isArray(jobs)
    ? [...new Set(jobs.map((job) => job.env_id).filter(Boolean))].sort()
    : [];
  const uniqueApps = Array.isArray(jobs)
    ? [...new Set(jobs.map((job) => job.app_id).filter(Boolean))].sort()
    : [];

  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const toInputFormat = (dbValue) => {
    if (!dbValue) return "";
    return dbValue.slice(0, 19).replace(" ", "T");
  };

  // Fetch dropdown options
  const fetchClients = async () => {
    try {
      const data = await apiService.get("/jobmonitoring/clients");
      setClients(Array.isArray(data) ? data : []);
    } catch (err) {
      setErrorMessage(err.message);
      setTimeout(() => setErrorMessage(""), 3000);
      setClients([]);
    }
  };

  const fetchEnvironments = async () => {
    try {
      const data = await apiService.get("/jobmonitoring/environments");
      setEnvironments(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching environments:", err);
      setEnvironments([]);
    }
  };

  const fetchApplications = async (envId = null) => {
    try {
      let url = "/jobmonitoring/applications";
      if (envId) {
        url += `?env_id=${envId}`;
      }
      const data = await apiService.get(url);
      setApplications(Array.isArray(data) ? data : []);
      return data;
    } catch (err) {
      console.error("Error fetching applications:", err);
      setApplications([]);
      return [];
    }
  };

  // Separate function for Load Jobs dialog applications
  const fetchLoadJobApplications = async (envId) => {
    try {
      if (!envId) {
        setLoadJobApplications([]);
        return [];
      }

      const url = `/jobmonitoring/applications?env_id=${envId}`;
      const data = await apiService.get(url);
      const applications = Array.isArray(data) ? data : [];
      setLoadJobApplications(applications);
      return applications;
    } catch (err) {
      console.error("Error fetching applications for Load Jobs:", err);
      setLoadJobApplications([]);
      return [];
    }
  };

  const fetchLogicalGroups = async (envId = null, appId = null) => {
    try {
      let url = "/jobmonitoring/logical-groups";
      const params = new URLSearchParams();
      if (envId) params.append("env_id", envId);
      if (appId) params.append("app_id", appId);
      if (params.toString()) url += `?${params.toString()}`;

      const data = await apiService.get(url);
      return Array.isArray(data) ? data : [];
    } catch (err) {
      console.error("Error fetching logical groups:", err);
      return [];
    }
  };
  useEffect(() => {
    if (!formData.cl_id || !formData.env_id || !formData.app_id) {
      setJobsList([]);
      return;
    }

    apiService
      .get(
        `/jobmonitoring/jobs/by-context?env_id=${formData.env_id}&app_id=${formData.app_id}`,
      )
      .then((data) => setJobsList(data))
      .catch(() => setJobsList([]));
  }, [formData.env_id, formData.app_id]);
  const handleJobChange = (e) => {
    const selectedJobId = e.target.value;
    const selectedJob = jobsList.find((j) => j.job_id === selectedJobId);

    setFormData((prev) => ({
      ...prev,
      job_id: selectedJobId,
      client_job_id: selectedJob?.client_job_id || "",
      master_file_loc: selectedJob?.master_file_loc || "",
    }));
  };

  const checkDateExists = async (date, env_id = "", app_id = "") => {
    try {
      const data = await apiService.post(`/jobmonitoring/check-date`, {
        date,
        env_id,
        app_id,
      });
      return data.exists;
    } catch (err) {
      console.error("Error checking date:", err.message);
      return false;
    }
  };

  const updateSingleField = async (js_id, field, value) => {
    //  Inline Required Validation (skip for active_flag since 0 is valid)
    if (field !== "active_flag" && (!value || value.toString().trim() === "")) {
      setEditError("This field is required");
      return; // stop API call
    }

    setEditError(""); // clear if valid

    try {
      const result = await apiService.patch(`/jobmonitoring/${js_id}/field`, {
        field,
        value,
      });

      setPaginatedData((prev) => ({
        ...prev,
        data: prev.data.map((job) =>
          job.js_id === js_id
            ? {
                ...job,
                [field]: value,
                ...(result.run_time !== undefined && {
                  run_time: result.run_time,
                }),
              }
            : job,
        ),
      }));

      // Don't show success message for active_flag - let the caller handle it
      if (field !== "active_flag") {
        setSuccessMessage(`${field.replace("_", " ")} updated successfully`);
        setTimeout(() => setSuccessMessage(""), 3000);
      }

      return result;
    } catch (err) {
      setErrorMessage(err.message || "Update failed");
      setTimeout(() => setErrorMessage(""), 3000);
      throw err; // keep caller logic safe
    }
  };

  const toIsoString = (val) => {
    return val?.replace(" ", "T")?.split(".")[0] || "";
  };

  const validate = () => {
    const errors = {};

    if (!formData.cl_id) errors.cl_id = "Client is required.";
    if (!formData.env_id) errors.env_id = "Environment is required.";
    if (!formData.app_id) errors.app_id = "Application is required.";
    if (!formData.job_id) errors.job_id = "Job ID is required.";

    if (formData.start_time && formData.end_time) {
      const start = new Date(toIsoString(formData.start_time));
      const end = new Date(toIsoString(formData.end_time));

      if (isNaN(start)) errors.start_time = "Invalid start time.";
      if (isNaN(end)) errors.end_time = "Invalid end time.";

      if (!errors.start_time && !errors.end_time && start > end) {
        errors.start_time = "Start time cannot be later than end time.";
        errors.end_time = "End time cannot be earlier than start time.";
      }
    }

    return errors;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Cascading handlers for Environment → Application → Logical Group → Job ID validation
  const handleEnvironmentChange = async (event, newValue) => {
    const envId = newValue ? newValue.env_id : "";
    setFormData((prev) => ({
      ...prev,
      env_id: envId,
      app_id: "", // Reset application when environment changes
      lg_id: "", // Reset logical group when environment changes
      job_id: "", // Reset job_id when environment changes
    }));

    // Fetch applications for the selected environment
    if (envId) {
      await fetchApplications(envId);
    } else {
      setApplications([]);
    }

    // Clear dependent dropdowns
    setLogicalGroups([]);
  };

  const handleApplicationChange = async (event, newValue) => {
    const appId = newValue ? newValue.app_id : "";
    setFormData((prev) => ({
      ...prev,
      app_id: appId,
      lg_id: "", // Reset logical group when application changes
      job_id: "", // Reset job_id when application changes
    }));

    // Fetch logical groups for the selected environment and application
    if (formData.env_id && appId) {
      const logicalGroupsData = await fetchLogicalGroups(
        formData.env_id,
        appId,
      );
      setLogicalGroups(logicalGroupsData);
    } else {
      setLogicalGroups([]);
    }
  };

  const handleLogicalGroupChange = (event, newValue) => {
    const lgId = newValue ? newValue.lg_id : "";
    setFormData((prev) => ({
      ...prev,
      lg_id: lgId,
      job_id: "", // Reset job_id when logical group changes
    }));
  };

  const formatDateTimeLocal = (datetimeStr) => {
    if (!datetimeStr) return "";
    return datetimeStr.slice(0, 19);
  };
  function getDateOnly(date = new Date()) {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().split("T")[0];
  }
  const handleDialogOpen = () => {
    const today = getDateOnly();
    // Pre-select the first (and likely only) client the user has access to
    const defaultClient = clients.length > 0 ? clients[0].cl_id : "";

    setFormData({
      cl_id: defaultClient,
      env_id: "",
      app_id: "",
      lg_id: "",
      js_id: "",
      job_id: "",
      client_job_id: "",
      scheduled_time: "",
      date_monitored: today,
      start_time: "",
      end_time: "",
      run_time: "",
      job_status: "",
      err_identified_by: "",
      comments: "",
      step_taken: "",
      active_flag: 1,
      master_file_loc: "",
    });
    setIsEditing(false);
    setFormErrors({});

    // Clear dependent dropdowns
    setApplications([]);
    setLogicalGroups([]);

    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setFormErrors({});
  };

  const handleEdit = async (job) => {
    setIsEditing(true);

    // First, load dependent data
    if (job.env_id) {
      await fetchApplications(job.env_id);
      if (job.app_id) {
        const logicalGroupsData = await fetchLogicalGroups(
          job.env_id,
          job.app_id,
        );
        setLogicalGroups(logicalGroupsData);
      }
    }

    // Then set form data after dependent data is loaded
    const editFormData = {
      ...job,

      // DATE input expects YYYY-MM-DD
      date_monitored: toDateOnly(job.date_monitored_raw),

      // datetime-local expects YYYY-MM-DDTHH:mm:ss
      start_time: toDateTimeLocal(job.start_time),
      end_time: toDateTimeLocal(job.end_time),
    };
    
    setFormData(editFormData);
    setOriginalFormData({ ...editFormData }); // Store original for change detection

    setOpenDialog(true);
  };
  const performClone = async (js_id) => {
    if (disabledButtons[js_id] || loading) return;

    setButtonsDisabled(js_id, true);

    try {
      const data = await apiService.post(`/jobmonitoring/${js_id}/clone`);

      setSuccessMessage(data.message || "Job cloned successfully");
      setTimeout(() => setSuccessMessage(""), 3000);

      await fetchPaginatedJobs(paginatedData.pagination.currentPage);
    } catch (err) {
      setErrorMessage("Error cloning job: " + err.message);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setButtonsDisabled(js_id, false);
    }
  };

  const handleDeleteClick = (js_id) => {
    setDeleteJsId(js_id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    if (!deleteJsId) return;

    try {
      setLoading(true);

      await apiService.delete(`/jobmonitoring/${deleteJsId}`);

      setSuccessMessage("Job deleted successfully.");
      setTimeout(() => setSuccessMessage(""), 3000);

      await fetchPaginatedJobs(paginatedData.pagination.currentPage);
    } catch (err) {
      let message =
        "Cannot delete this Job because related Job Status Details exist";

      if (
        err.response?.data?.message?.includes(
          "violates foreign key constraint",
        ) ||
        err.response?.data?.error?.includes("violates foreign key constraint")
      ) {
        message =
          "Cannot delete this Job because related Job Status Details exist.";
      }

      setErrorMessage(message);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
      setOpenDeleteDialog(false);
      setDeleteJsId(null);
    }
  };

  const cancelDelete = () => {
    setOpenDeleteDialog(false);
    setDeleteJsId(null);
  };

  const toDbFormat = (val) => {
    if (!val) return null;
    const [date, time] = val.split("T");
    return `${date} ${time.length === 5 ? time + ":00" : time}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔹 FRONTEND VALIDATION
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return; // ⛔ STOP backend call
    }

    try {
      const basePayload = {
        ...formData,
        client_job_id: formData.client_job_id || " ",
        start_time: formData.start_time
          ? toDbFormat(formData.start_time)
          : null,
        end_time: formData.end_time ? toDbFormat(formData.end_time) : null,
      };

      if (!isEditing) {
        const addPayload = {
          cl_id: basePayload.cl_id,
          env_id: basePayload.env_id,
          app_id: basePayload.app_id,
          job_id: basePayload.job_id,
          client_job_id: basePayload.client_job_id || null,
          date_monitored: basePayload.date_monitored,
          start_time: basePayload.start_time,
          end_time: basePayload.end_time,
          job_status: basePayload.job_status || null,
          err_identified_by: basePayload.err_identified_by || null,
          comments: basePayload.comments || null,
          step_taken: basePayload.step_taken || null,
          active_flag: 1,
        };

        await apiService.post(`/jobmonitoring`, addPayload);
        setSuccessMessage("Job added successfully");
      } else {
        if (!formData.js_id) {
          setErrorMessage("Job ID missing. Cannot update.");
          return;
        }

        await apiService.put(`/jobmonitoring/${formData.js_id}`, basePayload);
        setSuccessMessage("Job updated successfully");
      }

      setTimeout(() => setSuccessMessage(""), 3000);
      setOpenDialog(false);
      await fetchPaginatedJobs(paginatedData.pagination.currentPage);
    } catch (err) {
      setErrorMessage(err.message || "Failed to save job.");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const handleViewDetails = (js_id) => {
    const parentJob = paginatedData.data.find((j) => j.js_id === js_id);

    setSelectedJsId(js_id);
    setSelectedParentDate(parentJob?.date_monitored || "");
    setOpenDetailsDialog(true);
  };

  const handlePageChange = (event, value) => {
    fetchPaginatedJobs(value);
  };

  const setButtonsDisabled = (js_id, disabled) => {
    setDisabledButtons((prev) => ({ ...prev, [js_id]: disabled }));
  };

  const handleActiveFlagChange = async (js_id, currentFlag) => {
    if (disabledButtons[js_id] || loading) return;

    const newFlag = currentFlag === 1 ? 0 : 1;
    setButtonsDisabled(js_id, true);

    try {
      await updateSingleField(js_id, "active_flag", newFlag);

      // ✅ THIS IS THE FIX
      setPaginatedData((prev) => ({
        ...prev,
        data: prev.data.map((job) =>
          job.js_id === js_id ? { ...job, active_flag: newFlag } : job,
        ),
      }));

      setSuccessMessage(
        `Job ${newFlag === 1 ? "activated" : "deactivated"} successfully`,
      );

      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      setErrorMessage("Failed to update flag");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setButtonsDisabled(js_id, false);
    }
  };

  const handleToggleJobStatus = async (js_id) => {
    if (disabledButtons[js_id] || loading) return;

    setButtonsDisabled(js_id, true);

    try {
      const data = await apiService.patch(
        `/jobmonitoring/${js_id}/toggle-status`,
      );

      const { job_status } = data;

      setPaginatedData((prev) => ({
        ...prev,
        data: prev.data.map((job) =>
          job.js_id === js_id ? { ...job, job_status } : job,
        ),
      }));

      setSuccessMessage(`Job status updated to "${job_status}"`);
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      console.error("Toggle status error:", err);
      setErrorMessage(
        "Failed to toggle job status: " + (err.message || "Unknown error"),
      );
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setButtonsDisabled(js_id, false);
    }
  };

  const updateField = async (js_id, field, value) => {
    try {
      await apiService.patch(`/jobmonitoring/${js_id}/field`, { field, value });
      await fetchPaginatedJobs(paginatedData.pagination.currentPage);
    } catch (err) {
      setErrorMessage(err.message || "Failed to update field");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const handleCloneClick = (js_id) => {
    setConfirmClone({ open: true, js_id });
  };
  const columns = [
    "client_name",
    "environment_name",
    "application_name",
    "js_id",
    "job_id",
    "client_job_id",
    "lg_id",
    "job_name",
    "master_file_loc",
    "reference_1",
    "scope",
    "process_type",
    "date_monitored",
    "scheduled_time",
    "start_time",
    "end_time",
    "run_time",
    "job_status",
    "err_identified_by",
    "comments",
    "step_taken",
    "active_flag",
  ];

  const [showFilters, setShowFilters] = useState(true);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ width: "100%", maxWidth: "none" }}
    >
      {/* Header: Title and Action Buttons on the SAME line */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: showFilters ? 1 : 2 }}
      >
        {/* Job Monitoring Title */}
        <Typography
          variant="h4"
          fontSize="25px"
          fontWeight="600"
          color="#454545"
          sx={{ mb: 0 }}
        >
          Job Monitoring
        </Typography>

        {/* Right side: Buttons + Pagination all on the same line */}
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          justifyContent="space-between"
          sx={{ mb: 0 }}
        >
          {/* Action Buttons Group */}
          <Box display="flex" alignItems="center" gap={0.25} flexWrap="nowrap">
            {/* Filter Toggle */}
            <IconButton
              onClick={() => setShowFilters(!showFilters)}
              sx={{
                color: "#666",
                height: "35px",
                width: "30px",
                borderRadius: "8px",
                "&:hover": {
                  color: "#1976d2",
                },
              }}
            >
              {showFilters ? (
                <ExpandLessIcon fontSize="small" />
              ) : (
                <ExpandMoreIcon fontSize="small" />
              )}
            </IconButton>

            {/* Add + */}
            <Button
              onClick={handleDialogOpen}
              sx={{
                color: "#666",
                fontWeight: "bold",
                borderRadius: "8px",
                height: "35px",
                minWidth: "50px",
                px: 1.5,
                textTransform: "none",
                fontSize: "12px",
                "&:hover": {
                  color: "#1976d2",
                },
              }}
            >
              Add +
            </Button>

            {/* Sync */}
            <Tooltip title="Load Jobs">
              <IconButton
                onClick={() => setOpenStoredProcDialog(true)}
                sx={{
                  color: "#666",
                  height: "35px",
                  width: "30px",
                  borderRadius: "8px",
                  "&:hover": {
                    color: "#1976d2",
                  },
                }}
              >
                <SyncIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            {/* Clear Filters */}
            <Tooltip title="Clear Filters">
              <IconButton
                onClick={() => {
                  const today = getCurrentDate();
                  setFilter((prev) => ({
                    ...prev,
                    env_id: "",
                    app_id: "",
                    job_id: "",
                    job_name: "",
                    lg_id: "",
                    active_flag: "1",
                    date_monitored_from: today,
                    date_monitored_to: today,
                  }));
                  fetchPaginatedJobs(1);
                }}
                sx={{
                  color: "#666",
                  height: "35px",
                  width: "30px",
                  borderRadius: "8px",
                  "&:hover": {
                    color: "#1976d2",
                  },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            {/* Export CSV */}
            <Tooltip title="Export CSV">
              <IconButton
                onClick={() => setOpenExportDialog(true)}
                sx={{
                  color: "#666",
                  height: "35px",
                  width: "30px",
                  borderRadius: "8px",
                  "&:hover": {
                    color: "#1976d2",
                  },
                }}
              >
                <FileDownloadIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>

            {/* Settings */}

            <Tooltip title="Column Customization" arrow>
              <IconButton
                onClick={handleOpen}
                sx={{
                  color: "#666",
                  height: "35px",
                  width: "30px",
                  borderRadius: "8px",
                  "&:hover": {
                    color: "#1976d2",
                  },
                }}
              >
                <SettingsIcon style={{ width: 17, height: 17 }} />{" "}
                {/* Reduced size */}
              </IconButton>
            </Tooltip>
            <IconButton
              onClick={() => {
                const currentPage =
                  (paginatedData.pagination.currentPage || 1) - 1;
                if (currentPage > 0) fetchPaginatedJobs(currentPage);
              }}
              disabled={(paginatedData.pagination.currentPage || 1) <= 1}
              size="small" // Makes button smaller
              sx={{
                width: "30px",
                height: "35px",
                borderRadius: "6px",
                color: "#666",
                "&:hover": {
                  color: "#1976d2",
                },
                "&:disabled": {
                  color: "#ccc",
                },
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </svg>
            </IconButton>

            {/* Compact Pagination Text */}
            <Box
              sx={{
                fontSize: "13px", // Smaller font
                fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                whiteSpace: "nowrap",
                fontWeight: 500,
              }}
            >
              {`${((paginatedData.pagination.currentPage || 1) - 1) * rowsPerPage + 1}-${Math.min(
                (paginatedData.pagination.currentPage || 1) * rowsPerPage,
                paginatedData.pagination.totalRecords || 0,
              )} of ${paginatedData.pagination.totalRecords || 0}`}
            </Box>

            {/* Right Arrow - Smaller button */}
            <IconButton
              onClick={() => {
                const currentPage =
                  (paginatedData.pagination.currentPage || 1) + 1;
                const totalPages = Math.ceil(
                  (paginatedData.pagination.totalRecords || 0) / rowsPerPage,
                );
                if (currentPage <= totalPages) fetchPaginatedJobs(currentPage);
              }}
              disabled={
                (paginatedData.pagination.currentPage || 1) >=
                Math.ceil(
                  (paginatedData.pagination.totalRecords || 0) / rowsPerPage,
                )
              }
              size="small"
              sx={{
                width: "30px",
                height: "35px",
                borderRadius: "6px",
                color: "#666",
                "&:hover": {
                  color: "#1976d2",
                },
                "&:disabled": {
                  color: "#ccc",
                },
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </IconButton>
          </Box>

          {/* Custom Pagination */}

          {/* Left Arrow - Smaller button */}
        </Box>
      </Box>

      {/* Alerts (success/error) - placed right below the header */}
      {successMessage && <Alert severity="success">{successMessage}</Alert>}
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      {/* Filters Row - Only thin underline, labels always visible */}
      {showFilters && (
        <Box
          sx={{
            mb: 2,
            mt: 2,
            pt: 1.5,
            display: "flex",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: 1,
            pl: 0,
          }}
        >
          <Autocomplete
            size="small"
            options={filterOptions.environments}
            getOptionLabel={(opt) => opt.environment_name || opt.env_id}
            value={
              filterOptions.environments.find(
                (e) => e.env_id === filter.env_id,
              ) || null
            }
            onChange={(_, v) =>
              setFilter((prev) => ({
                ...prev,
                env_id: v?.env_id || "",
                app_id: "", // Reset application when environment changes
                job_id: "", // Reset job when environment changes
                lg_id: "", // Reset operations when environment changes
              }))
            }
            ListboxProps={{
              sx: {
                "& .MuiAutocomplete-option": {
                  fontSize: "0.875rem",
                  minHeight: "32px",
                },
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Environment"
                variant="outlined"
                size="small"
                sx={{
                  minWidth: 160,
                  "& .MuiInputBase-root": {
                    height: 36,
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.875rem",
                  },
                  "& input[type=number]": {
                    MozAppearance: "textfield",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />

          <Autocomplete
            size="small"
            options={
              filter.env_id && filteredApplications.length > 0
                ? filteredApplications
                : filterOptions.applications
            }
            getOptionLabel={(opt) =>
              opt.application_name || opt.name || opt.app_id
            }
            value={
              (filter.env_id && filteredApplications.length > 0
                ? filteredApplications
                : filterOptions.applications
              ).find((a) => a.app_id === filter.app_id) || null
            }
            onChange={(_, v) =>
              setFilter((prev) => ({
                ...prev,
                app_id: v?.app_id || "",
                job_id: "", // Reset job when application changes
                lg_id: "", // Reset operations when application changes
              }))
            }
            ListboxProps={{
              sx: {
                "& .MuiAutocomplete-option": {
                  fontSize: "0.875rem",
                  minHeight: "32px",
                },
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Application"
                variant="outlined"
                size="small"
                sx={{
                  minWidth: 170,
                  "& .MuiInputBase-root": {
                    height: 36,
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.875rem",
                  },
                  "& input[type=number]": {
                    MozAppearance: "textfield",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />

          <Autocomplete
            size="small"
            options={
              filter.env_id && filter.app_id && filteredJobs.length > 0
                ? filteredJobs
                : filterOptions.jobIds
            }
            getOptionLabel={(option) => option.job_id || ""}
            inputValue={filter.job_id || ""}
            onInputChange={(_, newValue) => {
              setFilter((prev) => ({ ...prev, job_id: newValue || "" }));
            }}
            onChange={(_, newValue) => {
              setFilter((prev) => ({
                ...prev,
                job_id: newValue ? newValue.job_id : filter.job_id,
              }));
            }}
            value={null}
            freeSolo
            selectOnFocus
            clearOnBlur={false}
            clearOnEscape={false}
            handleHomeEndKeys
            popupIcon={<ExpandMoreIcon sx={{ color: "#666" }} />}
            sx={{
              "& .MuiAutocomplete-popupIndicator": {
                "&:hover": { backgroundColor: "transparent" },
              },
            }}
            filterOptions={(options, { inputValue }) => {
              if (!inputValue) return options;
              const lower = inputValue.toLowerCase();
              return options.filter((opt) =>
                opt.job_id?.toLowerCase().includes(lower),
              );
            }}
            ListboxProps={{
              sx: {
                "& .MuiAutocomplete-option": {
                  fontSize: "0.875rem",
                  minHeight: "32px",
                },
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Job ID"
                variant="outlined"
                size="small"
                sx={{
                  minWidth: 90,
                  "& .MuiInputBase-root": {
                    height: 36,
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.875rem",
                  },
                  "& input[type=number]": {
                    MozAppearance: "textfield",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  ...params.inputProps,
                  onKeyDown: (e) => {
                    if (e.key === "Enter") {
                      e.stopPropagation();
                      e.preventDefault();
                      fetchPaginatedJobs(1);
                    }
                    if (params.inputProps?.onKeyDown) {
                      params.inputProps.onKeyDown(e);
                    }
                  },
                }}
              />
            )}
            noOptionsText="No matching Job ID"
            renderOption={(props, option) => (
              <li {...props} key={option.job_id}>
                {option.job_id}
              </li>
            )}
          />

          <Autocomplete
            size="small"
            options={
              filter.env_id && filter.app_id && filteredJobs.length > 0
                ? filteredJobs
                : filterOptions.jobIds
            }
            getOptionLabel={(option) =>
              option.jobs_script || option.job_name || ""
            }
            inputValue={filter.job_name || ""}
            onInputChange={(_, newValue) => {
              setFilter((prev) => ({ ...prev, job_name: newValue || "" }));
            }}
            onChange={(_, newValue) => {
              setFilter((prev) => ({
                ...prev,
                job_name: newValue
                  ? newValue.jobs_script || newValue.job_name
                  : filter.job_name,
              }));
            }}
            value={null}
            freeSolo
            selectOnFocus
            clearOnBlur={false}
            clearOnEscape={false}
            handleHomeEndKeys
            popupIcon={<ExpandMoreIcon sx={{ color: "#666" }} />}
            sx={{
              "& .MuiAutocomplete-popupIndicator": {
                "&:hover": { backgroundColor: "transparent" },
              },
            }}
            filterOptions={(options, { inputValue }) => {
              if (!inputValue) return options;
              const lower = inputValue.toLowerCase();
              return options.filter((opt) =>
                (opt.jobs_script || opt.job_name || "")
                  .toLowerCase()
                  .includes(lower),
              );
            }}
            ListboxProps={{
              sx: {
                "& .MuiAutocomplete-option": {
                  fontSize: "0.875rem",
                  minHeight: "32px",
                  padding: "4px 12px",
                },
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Job Script Name"
                variant="outlined"
                size="small"
                sx={{
                  minWidth: 200,
                  "& .MuiInputBase-root": {
                    height: 36,
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.875rem",
                  },
                  "& input[type=number]": {
                    MozAppearance: "textfield",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  ...params.inputProps,
                  onKeyDown: (e) => {
                    if (e.key === "Enter") {
                      e.stopPropagation();
                      e.preventDefault();
                      fetchPaginatedJobs(1);
                    }
                    if (params.inputProps?.onKeyDown) {
                      params.inputProps.onKeyDown(e);
                    }
                  },
                }}
              />
            )}
            noOptionsText="No matching script name"
            renderOption={(props, option) => (
              <li {...props} key={option.job_id}>
                {option.jobs_script || option.job_name}
              </li>
            )}
          />

          <TextField
            select
            label="Operations"
            size="small"
            variant="outlined"
            value={filter.lg_id}
            onChange={(e) =>
              setFilter((prev) => ({ ...prev, lg_id: e.target.value }))
            }
            sx={{
              minWidth: 90,
              "& .MuiInputBase-root": {
                height: 36,
              },
              "& .MuiInputBase-input": {
                fontSize: "0.875rem",
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.875rem",
              },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
              "& input[type=number]::-webkit-outer-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              "& input[type=number]::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
            }}
            InputLabelProps={{ shrink: true }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: "0.875rem",
                      minHeight: 32,
                    },
                  },
                },
              },
            }}
          >
            {(filter.app_id && filteredLogicalGroups.length > 0
              ? filteredLogicalGroups
              : filterOptions.operations || []
            )
              .filter((op) => {
                // Handle both object format {lg_id, name} and string format
                if (typeof op === "object" && op !== null) {
                  return op.lg_id && op.lg_id.toString().trim() !== "";
                }
                return op && op.toString().trim() !== "";
              })
              .map((op) => {
                // Handle both object format {lg_id, name} and string format
                const lgId = typeof op === "object" ? op.lg_id : op;
                const lgName = typeof op === "object" ? op.name : op;
                return (
                  <MenuItem
                    key={lgId}
                    value={lgId}
                    sx={{ fontSize: "0.875rem" }}
                  >
                    {lgName}
                  </MenuItem>
                );
              })}
          </TextField>

          <TextField
            select
            label="Active Flag"
            size="small"
            variant="outlined"
            value={filter.active_flag}
            onChange={(e) => {
              setFilter((prev) => ({ ...prev, active_flag: e.target.value }));
              fetchPaginatedJobs(1);
            }}
            sx={{
              minWidth: 80,
              "& .MuiInputBase-root": {
                height: 36,
              },
              "& .MuiInputBase-input": {
                fontSize: "0.875rem",
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.875rem",
              },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
              "& input[type=number]::-webkit-outer-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              "& input[type=number]::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
            }}
            InputLabelProps={{ shrink: true }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: "0.875rem",
                      minHeight: 32,
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="1" sx={{ fontSize: "0.875rem" }}>
              Active
            </MenuItem>
            <MenuItem value="0" sx={{ fontSize: "0.875rem" }}>
              Inactive
            </MenuItem>
            <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
              All
            </MenuItem>
          </TextField>

          <DatePicker
            selected={toDateObj(filter.date_monitored_from)}
            onChange={(date) => {
              const iso = date ? date.toLocaleDateString("en-CA") : "";
              setFilter((prev) => ({
                ...prev,
                date_monitored_from: iso,
                date_monitored_to:
                  prev.date_monitored_to === prev.date_monitored_from ||
                  !prev.date_monitored_to
                    ? iso
                    : prev.date_monitored_to,
              }));
            }}
            dateFormat="MMM dd yyyy"
            placeholderText="Date Monitored From"
            isClearable
            withPortal
            customInput={
              <TextField
                label="Date Monitored From"
                variant="outlined"
                size="small"
                sx={{
                  // ─────────────── Main controls ───────────────
                  width: 140,
                  maxWidth: 160,

                  "& .MuiInputBase-root": {
                    height: 36,
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.875rem",
                  },
                  // Optional: make label behave better when narrow
                  "& .MuiInputLabel- shrink": {
                    transform: "translate(14px, -9px) scale(0.75)",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
            }
          />

          <DatePicker
            selected={toDateObj(filter.date_monitored_to)}
            onChange={(date) => {
              const iso = date ? date.toLocaleDateString("en-CA") : "";
              setFilter((prev) => ({ ...prev, date_monitored_to: iso }));
            }}
            dateFormat="MMM dd yyyy"
            placeholderText="Date Monitored To"
            isClearable
            withPortal
            minDate={toDateObj(filter.date_monitored_from)}
            customInput={
              <TextField
                label="Date Monitored To"
                variant="outlined"
                size="small"
                sx={{
                  width: 140,

                  "& .MuiInputBase-root": {
                    height: 36,
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.875rem",
                  },
                  // Keep these if you have number inputs elsewhere — otherwise safe to remove
                  "& input[type=number]": {
                    MozAppearance: "textfield",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
            }
          />
        </Box>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            mt: 1,
            p: 1,
            width: 200,
            maxHeight: 300,
            overflowY: "auto",
            borderRadius: 2,
          },
        }}
      >
        {Object.keys(visibleColumns).map((col) => (
          <MenuItem key={col} disableGutters sx={{ p: 0, mb: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                border: "1px solid #ccc",
                borderRadius: 1.5,
                px: 2,
                py: 1,
                backgroundColor: "#fff",
              }}
            >
              <Typography
                sx={{ fontSize: "0.8rem", color: "#333", fontWeight: "Bold" }}
              >
                {columnLabels[col] || col}
              </Typography>
              <Switch
                size="small"
                checked={visibleColumns[col]}
                onChange={(e) =>
                  setVisibleColumns((prev) => ({
                    ...prev,
                    [col]: e.target.checked,
                  }))
                }
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#2DB0E4" },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#2DB0E4",
                  },
                }}
              />
            </Box>
          </MenuItem>
        ))}
      </Menu>

      {/* Export Dialog */}
      <Dialog
        open={openExportDialog}
        onClose={() => setOpenExportDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: 16, py: 1.5 }}>
          Export Job Monitoring Data
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* Date Range */}
            <Box sx={{ display: "flex", gap: 1.5 }}>
              <TextField
                type="date"
                label="Start Date"
                size="small"
                sx={{
                  flex: 1,
                  "& .MuiInputBase-root": { height: 40 },
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem",
                    padding: "10px 12px",
                  },
                  "& .MuiInputLabel-root": { fontSize: "0.875rem" },
                }}
                value={exportFilter.from}
                onChange={(e) =>
                  setExportFilter({ ...exportFilter, from: e.target.value })
                }
                InputLabelProps={{ shrink: true }}
                error={isInvalidDateRange()}
                helperText={
                  isInvalidDateRange()
                    ? "From Date cannot be after To Date"
                    : ""
                }
              />

              <TextField
                type="date"
                label="End Date"
                size="small"
                sx={{
                  flex: 1,
                  "& .MuiInputBase-root": { height: 40 },
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem",
                    padding: "10px 12px",
                  },
                  "& .MuiInputLabel-root": { fontSize: "0.875rem" },
                }}
                value={exportFilter.to}
                onChange={(e) =>
                  setExportFilter({ ...exportFilter, to: e.target.value })
                }
                InputLabelProps={{ shrink: true }}
                error={isInvalidDateRange()}
                helperText={
                  isInvalidDateRange()
                    ? "To Date cannot be before From Date"
                    : ""
                }
              />
            </Box>

            {/* Environment Filter */}
            <FormControl size="small" fullWidth>
              <InputLabel shrink sx={{ fontSize: "0.875rem" }}>
                Environment
              </InputLabel>
              <Select
                value={exportFilter.env_id}
                onChange={(e) =>
                  setExportFilter((prev) => ({
                    ...prev,
                    env_id: e.target.value,
                    app_id: "", // Reset application when environment changes
                  }))
                }
                label="Environment"
                displayEmpty
                sx={{
                  "& .MuiInputBase-root": { height: 40 },
                  "& .MuiSelect-select": {
                    fontSize: "0.875rem",
                    padding: "10px 12px",
                  },
                }}
              >
                <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
                  All Environments
                </MenuItem>
                {(uniqueEnvs || []).map((envId) => {
                  const env = environments.find((e) => e.env_id === envId);
                  return (
                    <MenuItem
                      key={envId}
                      value={envId}
                      sx={{ fontSize: "0.875rem" }}
                    >
                      {env ? env.name : envId}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            {/* Application Filter */}
            <FormControl size="small" fullWidth>
              <InputLabel shrink sx={{ fontSize: "0.875rem" }}>
                Application
              </InputLabel>
              <Select
                value={exportFilter.app_id}
                onChange={(e) =>
                  setExportFilter((prev) => ({
                    ...prev,
                    app_id: e.target.value,
                  }))
                }
                label="Application"
                displayEmpty
                sx={{
                  "& .MuiInputBase-root": { height: 40 },
                  "& .MuiSelect-select": {
                    fontSize: "0.875rem",
                    padding: "10px 12px",
                  },
                }}
              >
                <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
                  All Applications
                </MenuItem>
                {(uniqueApps || []).map((appId) => (
                  <MenuItem
                    key={appId}
                    value={appId}
                    sx={{ fontSize: "0.875rem" }}
                  >
                    {appId}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 1.5 }}>
          <Button
            onClick={() => setOpenExportDialog(false)}
            sx={{ fontSize: "0.875rem", textTransform: "none" }}
          >
            CANCEL
          </Button>
          {/* <Button
            variant="contained"
            onClick={handleCSVExport}
            sx={{ fontSize: "0.875rem", textTransform: "none" }}
          >
            Export
          </Button> */}
          <Button
            variant="contained"
            onClick={handleCSVExport}
            disabled={
              !exportFilter.from || !exportFilter.to || isInvalidDateRange()
            }
          >
            Export
          </Button>
        </DialogActions>
      </Dialog>

      <ThemeProvider theme={theme}>
        <Dialog
          open={openStoredProcDialog}
          onClose={() => {
            setOpenStoredProcDialog(false);
            setStoredProcDate("");
            setLoadJobFilters({ env_id: "", app_id: "" });
            setLoadJobApplications([]);
            setFormErrors({});
            setDateExistsError("");
          }}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            Run Job Load
            <IconButton
              onClick={() => {
                setOpenStoredProcDialog(false);
                setStoredProcDate("");
                setLoadJobFilters({ env_id: "", app_id: "" });
                setLoadJobApplications([]);
                setFormErrors({});
                setDateExistsError("");
              }}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Box display="grid" gridTemplateColumns="1fr" gap={2}>
              <TextField
                type="date"
                label="Select Date for Job Load *"
                name="storedProcDate"
                value={storedProcDate}
                onChange={async (e) => {
                  const selectedDate = e.target.value;
                  setStoredProcDate(selectedDate);
                  setFormErrors({});
                  setDateExistsError("");
                  
                  // Only check if ALL three fields are filled
                  if (selectedDate && loadJobFilters.env_id && loadJobFilters.app_id) {
                    const exists = await checkDateExists(
                      selectedDate,
                      loadJobFilters.env_id,
                      loadJobFilters.app_id,
                    );
                    if (exists) {
                      setDateExistsError(
                        "Jobs already created for that date with selected filters",
                      );
                    }
                  }
                }}
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={!!formErrors.storedProcDate || !!dateExistsError}
                helperText={formErrors.storedProcDate || dateExistsError}
              />

              <Autocomplete
                options={filterOptions.environments}
                getOptionLabel={(option) => option.environment_name || ""}
                value={
                  filterOptions.environments.find(
                    (env) => env.env_id === loadJobFilters.env_id,
                  ) || null
                }
                onChange={async (event, newValue) => {
                  const newEnvId = newValue ? newValue.env_id : "";
                  setLoadJobFilters((prev) => ({
                    ...prev,
                    env_id: newEnvId,
                    app_id: "", // Reset application when environment changes
                  }));
                  setFormErrors((prev) => ({
                    ...prev,
                    env_id: "",
                    app_id: "",
                  }));
                  setDateExistsError("");

                  // Fetch applications for the selected environment
                  if (newEnvId) {
                    await fetchLoadJobApplications(newEnvId);
                  } else {
                    setLoadJobApplications([]);
                  }

                  // Only check if ALL three fields are filled
                  // Note: app_id is reset above, so this won't trigger until app is selected again
                }}
                ListboxProps={{
                  sx: {
                    "& .MuiAutocomplete-option": {
                      fontSize: "0.875rem",
                      minHeight: "32px",
                    },
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Environment (Required)"
                    size="small"
                    error={!!formErrors.env_id}
                    helperText={formErrors.env_id}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "0.875rem",
                      },
                    }}
                  />
                )}
              />

              <Autocomplete
                options={loadJobApplications}
                getOptionLabel={(option) =>
                  option.name || option.application_name || ""
                }
                value={
                  loadJobApplications.find(
                    (app) => app.app_id === loadJobFilters.app_id,
                  ) || null
                }
                onChange={async (event, newValue) => {
                  const newAppId = newValue ? newValue.app_id : "";
                  setLoadJobFilters((prev) => ({
                    ...prev,
                    app_id: newAppId,
                  }));
                  setFormErrors((prev) => ({ ...prev, app_id: "" }));
                  setDateExistsError("");

                  // Only check if ALL three fields are filled
                  if (storedProcDate && loadJobFilters.env_id && newAppId) {
                    const exists = await checkDateExists(
                      storedProcDate,
                      loadJobFilters.env_id,
                      newAppId,
                    );
                    if (exists) {
                      setDateExistsError(
                        "Jobs already created for that date with selected filters",
                      );
                    }
                  }
                }}
                disabled={!loadJobFilters.env_id}
                ListboxProps={{
                  sx: {
                    "& .MuiAutocomplete-option": {
                      fontSize: "0.875rem",
                      minHeight: "32px",
                    },
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Application (Required)"
                    size="small"
                    error={!!formErrors.app_id}
                    helperText={formErrors.app_id}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "0.875rem",
                      },
                    }}
                  />
                )}
                noOptionsText={
                  !loadJobFilters.env_id
                    ? "Please select an environment first"
                    : "No applications available"
                }
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenStoredProcDialog(false);
                setStoredProcDate("");
                setLoadJobFilters({ env_id: "", app_id: "" });
                setLoadJobApplications([]);
                setFormErrors({});
                setDateExistsError("");
              }}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              onClick={async () => {
                const errors = {};
                if (!storedProcDate) {
                  errors.storedProcDate = "Date is required.";
                }

                if (Object.keys(errors).length > 0) {
                  setFormErrors(errors);
                  return;
                }

                if (dateExistsError) {
                  return;
                }

                try {
                  setLoading(true);

                  // Validate required fields
                  if (!loadJobFilters.env_id) {
                    setFormErrors({ env_id: "Environment is required" });
                    setLoading(false);
                    return;
                  }
                  if (!loadJobFilters.app_id) {
                    setFormErrors({ app_id: "Application is required" });
                    setLoading(false);
                    return;
                  }

                  const payload = {
                    date: storedProcDate,
                    env_id: loadJobFilters.env_id,
                    app_id: loadJobFilters.app_id,
                  };

                  const data = await apiService.post(
                    `/jobmonitoring/run-job-load`,
                    payload,
                  );
                  setSuccessMessage(
                    data.message || "Job load executed successfully.",
                  );
                  setTimeout(() => setSuccessMessage(""), 3000);
                  setOpenStoredProcDialog(false);
                  setStoredProcDate("");
                  setLoadJobFilters({ env_id: "", app_id: "" });
                  setLoadJobApplications([]);
                  await fetchPaginatedJobs(
                    paginatedData.pagination.currentPage,
                  );
                } catch (err) {
                  setErrorMessage(`Error running job load: ${err.message}`);
                  setTimeout(() => setErrorMessage(""), 3000);
                } finally {
                  setLoading(false);
                }
              }}
              variant="contained"
              disabled={loading || !!dateExistsError}
            >
              Run
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          mt: 2,
        }}
      >
        <ThemeProvider theme={Table_theme}>
          <CssBaseline />

          <Paper elevation={1}>
            <TableContainer
              sx={{
                flexGrow: 1,
                maxHeight: "calc(100vh - 210px)", // filters + header

                overflowY: "auto",
                overflowX: "auto",
              }}
            >
              <Table stickyHeader>
                <TableHead sx={{ bgcolor: "#f5f5f5" }}>
                  <TableRow>
                    <TableCell>Actions</TableCell>
                    {columns.map(
                      (col) =>
                        visibleColumns[col] && (
                          <TableCell
                            key={col}
                            onClick={() =>
                              ["js_id", "job_id", "scheduled_time"].includes(
                                col,
                              )
                                ? handleSort(col)
                                : null
                            }
                            sx={{
                              cursor: [
                                "js_id",
                                "job_id",
                                "scheduled_time",
                              ].includes(col)
                                ? "pointer"
                                : "default",
                              "&:hover": [
                                "js_id",
                                "job_id",
                                "scheduled_time",
                              ].includes(col)
                                ? { backgroundColor: "#e0e0e0" }
                                : {},
                            }}
                          >
                            {columnLabels[col] || col}
                            {["js_id", "job_id", "scheduled_time"].includes(
                              col,
                            ) && (
                              <span>
                                {sortConfig.key === col
                                  ? sortConfig.direction === "asc"
                                    ? " ▲"
                                    : " ▼"
                                  : ""}
                              </span>
                            )}
                          </TableCell>
                        ),
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell
                        colSpan={
                          Object.keys(visibleColumns).filter(
                            (col) => visibleColumns[col],
                          ).length + 1
                        }
                        sx={{ 
                          position: "sticky",
                          left: 0,
                          textAlign: "left", 
                          padding: "20px",
                          backgroundColor: "white",
                          zIndex: 1
                        }}
                      >
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : paginatedData.data.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={
                          Object.keys(visibleColumns).filter(
                            (col) => visibleColumns[col],
                          ).length + 1
                        }
                        sx={{ 
                          position: "sticky",
                          left: 0,
                          textAlign: "left", 
                          padding: "20px",
                          backgroundColor: "white",
                          zIndex: 1
                        }}
                      >
                        No job monitoring records found.
                      </TableCell>
                    </TableRow>
                  ) : (
                    paginatedData.data.map((job) => (
                      <TableRow key={job.js_id}>
                        <TableCell>
                          <Box
                            display="flex"
                            gap={1}
                            flexWrap="nowrap"
                            sx={{ minWidth: "max-content" }}
                          >
                            <IconButton
                              size="small"
                              onClick={() =>
                                setEditField({
                                  js_id: job.js_id,
                                  field: "start_time",
                                  value: job.start_time,
                                })
                              }
                              title="Update Start Time"
                              disabled={loading}
                            >
                              <StartTimeIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() =>
                                setEditField({
                                  js_id: job.js_id,
                                  field: "end_time",
                                  value: job.end_time,
                                })
                              }
                              title="Update End Time"
                              disabled={loading}
                            >
                              <EndTimeIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              title="Toggle Job Status"
                              onClick={() => handleToggleJobStatus(job.js_id)}
                              disabled={disabledButtons[job.js_id] || loading}
                            >
                              {job.job_status === "Completed" ? (
                                <SuccessIcon
                                  style={{
                                    width: 17,
                                    height: 19,
                                    color: "#00C853", // green
                                  }}
                                />
                              ) : job.job_status === "Failed" ? (
                                <FailureIcon
                                  style={{
                                    width: 17,
                                    height: 19,
                                    color: "#D32F2F", // red
                                  }}
                                />
                              ) : job.job_status === "Failed & Recovered" ? (
                                <FailedRecoveredIcon
                                  style={{
                                    width: 17,
                                    height: 19,
                                    color: "#FB8C00", //  orange
                                  }}
                                />
                              ) : job.job_status === "Running" ? (
                                <PlayCircleOutlinedIcon
                                  style={{
                                    color: "#1976D2", // blue for running
                                    width: 18,
                                    height: 18,
                                  }}
                                />
                              ) : (
                                <NilIcon
                                  style={{
                                    width: 17,
                                    height: 19,
                                    color: "#9E9E9E", // grey
                                  }}
                                />
                              )}
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() =>
                                setEditField({
                                  js_id: job.js_id,
                                  field: "comments",
                                  value: job.comments,
                                })
                              }
                              title="Failure Reason"
                              disabled={loading}
                            >
                              <FailureReasonIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() =>
                                setEditField({
                                  js_id: job.js_id,
                                  field: "step_taken",
                                  value: job.step_taken,
                                })
                              }
                              title="Notes"
                              disabled={loading}
                            >
                              <NotesIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              title="Clone row"
                              onClick={() => handleCloneClick(job.js_id)}
                              disabled={disabledButtons[job.js_id] || loading}
                            >
                              <CloneIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              // onClick={() => handleDelete(job.js_id)}
                              onClick={() => handleDeleteClick(job.js_id)}
                              sx={{ color: "error.main" }}
                              disabled={loading}
                              title="Delete"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              onClick={() => handleEdit(job)}
                              sx={{ color: "#2DB0E4" }}
                              disabled={loading}
                              title="Edit"
                            >
                              <EditIcon
                                style={{
                                  width: 12,
                                  height: 15,
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                            <IconButton
                              size="small"
                              title="Toggle Active Flag"
                              onClick={() =>
                                handleActiveFlagChange(
                                  job.js_id,
                                  job.active_flag,
                                )
                              }
                              disabled={disabledButtons[job.js_id] || loading}
                            >
                              <FlagIcon
                                title="Delete Flag"
                                style={{
                                  color:
                                    job.active_flag === 1
                                      ? "#00CC22"
                                      : "#FF0C0C",
                                  transition: "color 0.1s",
                                  width: 12,
                                  height: 15,
                                  verticalAlign: "middle",
                                }}
                              />
                            </IconButton>
                            <IconButton
                              onClick={() => handleViewDetails(job.js_id)}
                              sx={{ color: "#2db0e4" }}
                              disabled={loading}
                              title="View Substage Details"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                        {visibleColumns.client_name && (
                          <TableCell>{job.client_name}</TableCell>
                        )}
                        {visibleColumns.environment_name && (
                          <TableCell>{job.environment_name}</TableCell>
                        )}
                        {visibleColumns.application_name && (
                          <TableCell>{job.application_name}</TableCell>
                        )}
                        {visibleColumns.js_id && (
                          <TableCell>{job.js_id}</TableCell>
                        )}
                        {visibleColumns.job_id && (
                          <TableCell>{job.job_id}</TableCell>
                        )}
                        {visibleColumns.client_job_id && (
                          <TableCell>{job.client_job_id}</TableCell>
                        )}
                        {visibleColumns.lg_id && (
                          <TableCell>{job.lg_id}</TableCell>
                        )}
                        {visibleColumns.job_name && (
                          <TableCell>{job.job_name}</TableCell>
                        )}
                        {visibleColumns.master_file_loc && (
                          <TableCell>{job.master_file_loc}</TableCell>
                        )}
                        {visibleColumns.reference_1 && (
                          <TableCell>{job.reference_1}</TableCell>
                        )}
                        {visibleColumns.scope && (
                          <TableCell>{job.scope}</TableCell>
                        )}
                        {visibleColumns.process_type && (
                          <TableCell>{job.process_type}</TableCell>
                        )}
                        {visibleColumns.date_monitored && (
                          <TableCell>{job.date_monitored}</TableCell>
                        )}
                        {visibleColumns.scheduled_time && (
                          <TableCell>{job.scheduled_time}</TableCell>
                        )}

                        {visibleColumns.start_time && (
                          <TableCell>
                            {job.start_time
                              ? formatDateTimeLocal(job.start_time)
                              : "NA"}
                          </TableCell>
                        )}

                        {visibleColumns.end_time && (
                          <TableCell>
                            {job.end_time
                              ? formatDateTimeLocal(job.end_time)
                              : "NA"}
                          </TableCell>
                        )}
                        {visibleColumns.run_time && (
                          <TableCell>{job.run_time || "NA"}</TableCell>
                        )}
                        {visibleColumns.job_status && (
                          <TableCell>{job.job_status}</TableCell>
                        )}
                        {visibleColumns.err_identified_by && (
                          <TableCell>{job.err_identified_by}</TableCell>
                        )}
                        {visibleColumns.comments && (
                          <TableCell>{job.comments}</TableCell>
                        )}
                        {visibleColumns.step_taken && (
                          <TableCell>{job.step_taken}</TableCell>
                        )}
                        {visibleColumns.active_flag && (
                          <TableCell>
                            {job.active_flag === 1 ? "Yes" : "No"}
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </ThemeProvider>

        <ThemeProvider theme={theme}>
          {/* <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            fullWidth
            maxWidth="md"
          > */}
          <Dialog
            open={openDialog}
            onClose={(event, reason) => {
              if (reason === "backdropClick") return;
              setOpenDialog(false);
            }}
           fullWidth
          maxWidth="md"
          >
            <DialogTitle
              sx={{
                fontWeight: "700",
                fontSize: "16px",
                py: 1,
              }}
            >
              {isEditing ? "Edit Job Monitoring" : "Add Job Monitoring"}
              <IconButton
                onClick={handleDialogClose}
                sx={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 1.1 }}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: 1,
                }}
              >
                <TextField
                  label="Client ID"
                  value={
                    clients.find((c) => c.cl_id === formData.cl_id)?.name ||
                    formData.cl_id ||
                    ""
                  }
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    minWidth: 260,
                    "& .MuiInputBase-input": {
                      backgroundColor: "white",
                      color: "grey",
                      cursor: "not-allowed",
                    },
                  }}
                  required
                  fullWidth
                />
                {/* Environment */}
                <Autocomplete
                  options={environments}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    environments.find(
                      (env) => env.env_id === formData.env_id,
                    ) || null
                  }
                  onChange={handleEnvironmentChange}
                  ListboxProps={{
                    sx: {
                      minWidth: 260,
                      "& .MuiAutocomplete-option": {
                        fontSize: "0.875rem",
                        minHeight: "32px",
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Environment"
                      error={!!formErrors.env_id}
                      helperText={formErrors.env_id}
                      required
                      disabled={isEditing}
                      sx={{
                         minWidth: 260,
                        "& .MuiInputBase-input": {
                          fontSize: "0.875rem",
                          backgroundColor: isEditing ? "white" : "white",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: isEditing,
                      }}
                    />
                  )}
                  disabled={isEditing || environments.length === 0}
                />

                {/* Application */}
                <Autocomplete
                  options={applications}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    applications.find(
                      (app) => app.app_id === formData.app_id,
                    ) || null
                  }
                  onChange={handleApplicationChange}
                  ListboxProps={{
                    sx: {
                      minWidth: 260,
                      "& .MuiAutocomplete-option": {
                        fontSize: "0.875rem",
                        minHeight: "32px",
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Application"
                      error={!!formErrors.app_id}
                      helperText={formErrors.app_id}
                      required
                      disabled={isEditing}
                      sx={{
                        minWidth: 260,
                        "& .MuiInputBase-input": {
                          fontSize: "0.875rem",
                          backgroundColor: isEditing ? "white" : "white",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: isEditing,
                      }}
                    />
                  )}
                  disabled={isEditing || !formData.env_id || applications.length === 0}
                  noOptionsText={
                    !formData.env_id
                      ? "Please select an environment first"
                      : "No applications available"
                  }
                />

                {/* Logical Group */}
                <Autocomplete
                  options={logicalGroups}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    logicalGroups.find(
                      (group) => group.lg_id === formData.lg_id,
                    ) || null
                  }
                  onChange={handleLogicalGroupChange}
                  ListboxProps={{
                    sx: {
                      minWidth: 260,
                      "& .MuiAutocomplete-option": {
                        fontSize: "0.875rem",
                        minHeight: "32px",
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Logical Group"
                      error={!!formErrors.lg_id}
                      disabled={isEditing}
                      sx={{
                        minWidth: 260,
                        "& .MuiInputBase-input": {
                          fontSize: "0.875rem",
                          backgroundColor: isEditing ? "white" : "white",
                        },
                        "& .MuiFormHelperText-root": {
                          minHeight: "1.25rem",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: isEditing,
                      }}
                    />
                  )}
                  disabled={isEditing || !formData.app_id || logicalGroups.length === 0}
                  noOptionsText={
                    !formData.app_id
                      ? "Please select an application first"
                      : "No logical groups available"
                  }
                />
                {/* Job ID */}
                <TextField
                  select
                  label="Job ID"
                  name="job_id"
                  value={formData.job_id || ""}
                  onChange={(e) => {
                    handleJobChange(e);

                    // Clear validation error when user selects value
                    setFormErrors((prev) => ({
                      ...prev,
                      job_id: "",
                    }));
                  }}
                  required
                  disabled={isEditing}
                  error={!!formErrors.job_id}
                  helperText={formErrors.job_id}
                  fullWidth
                  size="small"
                  InputProps={{
                    readOnly: isEditing,
                  }}
                  sx={{
                    minWidth: 260,
                    "& .MuiInputBase-input": {
                      fontSize: "0.875rem",
                      backgroundColor: isEditing ? "white" : "white",
                    },
                    "& .MuiFormHelperText-root": {
                      minHeight: "16px",
                    },
                  }}
                >
                  {jobsList.map((job) => (
                    <MenuItem key={job.job_id} value={job.job_id}>
                      {job.job_id} - {job.jobs_script}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Client Job ID (auto-filled, editable optional) */}
                <TextField
                  label="Client Job ID"
                  name="client_job_id"
                  value={formData.client_job_id || ""}
                  disabled={isEditing}
                  onChange={handleChange}
                  InputProps={{
                    readOnly: isEditing,
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      backgroundColor: isEditing ? "white" : "white",
                    },
                  }}
                />
                <TextField
                  label="Master File Location"
                  name="master_file_loc"
                  value={formData.master_file_loc || ""}
                  onChange={handleChange}
                  disabled={isEditing}
                  InputProps={{
                    readOnly: isEditing,
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      backgroundColor: isEditing ? "white" : "white",
                    },
                  }}
                />

                {isEditing && (
                  <TextField
                    label="Scheduled Time"
                    type="time"
                    name="scheduled_time"
                    value={formData.scheduled_time || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        scheduled_time: e.target.value,
                      }))
                    }
                    InputLabelProps={{ shrink: true }}
                      sx={{
                    minWidth: 260,
                    "& .MuiInputBase-input": {
                      fontSize: "0.875rem",
                    },
                    "& .MuiFormHelperText-root": {
                      minHeight: "16px", // prevent layout jump
                    },
                  }}
                    InputProps={{ inputProps: { step: 1 } }}
                  />
                )}
                <TextField
                  type="date"
                  label="Date Monitored"
                  InputLabelProps={{ shrink: true }}
                  name="date_monitored"
                  value={formData.date_monitored || ""}
                    sx={{
                    minWidth: 260,
                    "& .MuiInputBase-input": {
                      fontSize: "0.875rem",
                    },
                    "& .MuiFormHelperText-root": {
                      minHeight: "16px", // prevent layout jump
                    },
                  }}
                  onChange={(e) =>
                    setFormData({ ...formData, date_monitored: e.target.value })
                  }
                />

                <TextField
                  type="datetime-local"
                  label="Start Time"
                  InputProps={{ inputProps: { step: 1 } }}
                  InputLabelProps={{ shrink: true }}
                  value={formData.start_time || ""}
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, start_time: e.target.value }))
                  }
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData("text");
                    const result = parsePastedDateTime(pastedText);

                    if (result.success) {
                      setFormData((p) => ({ ...p, start_time: result.value }));
                      // Clear any previous errors
                      setFormErrors((prev) => ({ ...prev, start_time: "" }));
                    } else {
                      // Show error message
                      setFormErrors((prev) => ({
                        ...prev,
                        start_time: result.error,
                      }));
                      setErrorMessage(result.error);
                      setTimeout(() => {
                        setErrorMessage("");
                        setFormErrors((prev) => ({ ...prev, start_time: "" }));
                      }, 5000);
                    }
                  }}
                  error={!!formErrors.start_time}
                  helperText={formErrors.start_time}
                    sx={{
                    minWidth: 260,
                    "& .MuiInputBase-input": {
                      fontSize: "0.875rem",
                    },
                    "& .MuiFormHelperText-root": {
                      minHeight: "16px", // prevent layout jump
                    },
                  }}
                />

                <TextField
                  type="datetime-local"
                  label="End Time"
                  InputProps={{ inputProps: { step: 1 } }}
                  InputLabelProps={{ shrink: true }}
                  value={formData.end_time || ""}
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, end_time: e.target.value }))
                  }
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData("text");
                    const result = parsePastedDateTime(pastedText);

                    if (result.success) {
                      setFormData((p) => ({ ...p, end_time: result.value }));
                      // Clear any previous errors
                      setFormErrors((prev) => ({ ...prev, end_time: "" }));
                    } else {
                      // Show error message
                      setFormErrors((prev) => ({
                        ...prev,
                        end_time: result.error,
                      }));
                      setErrorMessage(result.error);
                      setTimeout(() => {
                        setErrorMessage("");
                        setFormErrors((prev) => ({ ...prev, end_time: "" }));
                      }, 5000);
                    }
                  }}
                  error={!!formErrors.end_time}
                  helperText={formErrors.end_time}
                    sx={{
                    minWidth: 260,
                    "& .MuiInputBase-input": {
                      fontSize: "0.875rem",
                    },
                    "& .MuiFormHelperText-root": {
                      minHeight: "16px", // prevent layout jump
                    },
                  }}
                />
                <TextField
                  select
                  label="Job Status"
                  name="job_status"
                  value={formData.job_status || ""}
                  onChange={handleChange}
                    sx={{
                    minWidth: 260,
                    "& .MuiInputBase-input": {
                      fontSize: "0.875rem",
                    },
                    "& .MuiFormHelperText-root": {
                      minHeight: "16px", // prevent layout jump
                    },
                  }}
                >
                  <MenuItem value="Completed" sx={{ fontSize: "0.875rem" }}>
                    Completed
                  </MenuItem>
                  <MenuItem value="Failed" sx={{ fontSize: "0.875rem" }}>
                    Failed
                  </MenuItem>
                  <MenuItem value="Running" sx={{ fontSize: "0.875rem" }}>
                    Running
                  </MenuItem>
                  <MenuItem
                    value="Failed & Recovered"
                    sx={{ fontSize: "0.875rem" }}
                  >
                    Failed & Recovered
                  </MenuItem>
                  <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
                    Clear
                  </MenuItem>
                </TextField>
                <TextField
                  select
                  label="Recovered By"
                  name="err_identified_by"
                  value={formData.err_identified_by || ""}
                  onChange={handleChange}
                >
                  <MenuItem
                    value="Recovered by BFx"
                    sx={{ fontSize: "0.875rem" }}
                  >
                    Recovered by BFx
                  </MenuItem>
                  <MenuItem
                    value={getRecoveredByClientLabel()}
                    sx={{ fontSize: "0.875rem" }}
                  >
                    {getRecoveredByClientLabel()}
                  </MenuItem>
                  <MenuItem value="" sx={{ fontSize: "0.875rem" }}>
                    Clear
                  </MenuItem>
                </TextField>
                <TextField
                  label="Steps Taken"
                  name="step_taken"
                  value={formData.step_taken || ""}
                  onChange={handleChange}
                  multiline
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  label="Failure Reason"
                  name="comments"
                  value={formData.comments || ""}
                  onChange={handleChange}
                  multiline
                          rows={4}
                          sx={{
                            gridColumn: "span 3",
                            ...compactMultilineStyles,
                            width: "100%",
                          }}
                />
                
              </Box>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleDialogClose} disabled={loading}>
                Cancel
              </Button>
              <Button
                onClick={handleSubmit}
                variant="contained"
                disabled={loading || (isEditing && !hasFormChanged())}
              >
                {isEditing ? "Update" : "Add"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* <Dialog
            open={!!editField}
            onClose={() => {
              setEditField(null);
              setFormErrors({});
            }} */}
          <Dialog
            open={Boolean(editField)}
            onClose={() => setEditField(null)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>
              {editField?.field === "comments"
                ? "EDIT FAILURE REASON"
                : editField?.field === "step_taken"
                  ? "EDIT NOTES"
                  : `Edit ${editField?.field.replace("_", " ").toUpperCase()}`}
            </DialogTitle>
            <DialogContent>
              {editField?.field === "start_time" ||
              editField?.field === "end_time" ? (
                <TextField
                  autoFocus
                  margin="dense"
                  label={`New ${editField.field.replace("_", " ")}`}
                  type="datetime-local"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      // Push label a bit higher so it doesn't get cut
                      transform: "translate(14px, -9px) scale(0.75) !important",
                      // or more aggressive:
                      // transform: 'translate(14px, -12px) scale(0.75) !important',

                      // Optional: make background cover the border better
                      backgroundColor: "#fff",
                      padding: "0 6px",
                    },
                  }}
                  InputProps={{ step: 1 }} // enables seconds in picker
                  value={editField.value ? toInputFormat(editField.value) : ""}
                  // MAIN CHANGE HANDLER (keeps your existing validation)
                  onChange={(e) => {
                    const input = e.target.value; // e.g., "2025-12-24T02:30:00"
                    const newValue = toDbFormat(input); // → "2025-12-24 02:30:00"

                    setEditField((prev) => {
                      const otherTime =
                        prev.field === "start_time"
                          ? prev.other_end_time
                          : prev.other_start_time;

                      const toIso = (val) =>
                        val ? val.replace(" ", "T").split(".")[0] : null;

                      const thisTime = toIso(newValue);
                      const compareTime = toIso(otherTime);

                      const errors = {};
                      if (thisTime && compareTime) {
                        if (
                          prev.field === "start_time" &&
                          new Date(thisTime) > new Date(compareTime)
                        ) {
                          errors.start_time =
                            "Start time cannot be later than end time.";
                        }
                        if (
                          prev.field === "end_time" &&
                          new Date(thisTime) < new Date(compareTime)
                        ) {
                          errors.end_time =
                            "End time cannot be earlier than start time.";
                        }
                      }
                      setFormErrors(errors);

                      return { ...prev, value: newValue };
                    });
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData("text");
                    const result = parsePastedDateTime(pastedText);

                    if (result.success) {
                      const newValue = toDbFormat(result.value);

                      setEditField((prev) => {
                        const otherTime =
                          prev.field === "start_time"
                            ? prev.other_end_time
                            : prev.other_start_time;

                        const toIso = (val) =>
                          val ? val.replace(" ", "T").split(".")[0] : null;
                        const thisTime = toIso(newValue);
                        const compareTime = toIso(otherTime);

                        const errors = {};
                        if (thisTime && compareTime) {
                          if (
                            prev.field === "start_time" &&
                            new Date(thisTime) > new Date(compareTime)
                          ) {
                            errors.start_time =
                              "Start time cannot be later than end time.";
                          }
                          if (
                            prev.field === "end_time" &&
                            new Date(thisTime) < new Date(compareTime)
                          ) {
                            errors.end_time =
                              "End time cannot be earlier than start time.";
                          }
                        }

                        setFormErrors(errors);

                        return {
                          ...prev,
                          value: newValue,
                        };
                      });
                    } else {
                      // Show error message for invalid format
                      setErrorMessage(result.error);
                      setTimeout(() => setErrorMessage(""), 5000);
                    }
                  }}
                />
              ) : (
                <TextField
                  autoFocus
                  margin="dense"
                  variant="outlined"
                  label={
                    editField?.field === "comments"
                      ? "New Failure Reason"
                      : editField?.field === "step_taken"
                        ? "New Notes"
                        : `New ${editField?.field.replace("_", " ")}`
                  }
                  type="text"
                  fullWidth
                  value={editField?.value || ""}
                  onChange={(e) => {
                    setEditField({ ...editField, value: e.target.value });

                    if (editError) setEditError(""); // clear error while typing
                  }}
                  error={!!editError}
                  helperText={editError || " "}
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      // Push label a bit higher so it doesn't get cut
                      transform: "translate(14px, -9px) scale(0.75) !important",
                      // or more aggressive:
                      // transform: 'translate(14px, -12px) scale(0.75) !important',

                      // Optional: make background cover the border better
                      backgroundColor: "#fff",
                      padding: "0 6px",
                    },
                  }}
                />
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setEditField(null)}
                // variant="outlined"
              >
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  const job = jobs.find((j) => j.js_id === editField.js_id);
                  const errors = {};

                  const toIso = (val) =>
                    val ? val.replace(" ", "T").split(".")[0] : null;

                  // =====================
                  // VALIDATION
                  // =====================
                  if (editField.field === "start_time" && job?.end_time) {
                    const start = new Date(toIso(editField.value));
                    const end = new Date(toIso(job.end_time));

                    if (start > end) {
                      errors.start_time =
                        "Start time cannot be later than end time.";
                      setFormErrors(errors);
                      return;
                    }
                  }

                  if (editField.field === "end_time" && job?.start_time) {
                    const end = new Date(toIso(editField.value));
                    const start = new Date(toIso(job.start_time));

                    if (end < start) {
                      errors.end_time =
                        "End time cannot be earlier than start time.";
                      setFormErrors(errors);
                      return;
                    }
                  }

                  // =====================
                  // FINAL NORMALIZATION
                  // =====================
                  const normalizeForBackend = (val) => {
                    if (!val) return null;
                    return val.includes("T")
                      ? val.replace("T", " ") + ":00"
                      : val;
                  };

                  const safeValue =
                    editField.field === "start_time" ||
                    editField.field === "end_time"
                      ? normalizeForBackend(editField.value)
                      : editField.value;

                  if (
                    (editField.field === "start_time" ||
                      editField.field === "end_time") &&
                    !safeValue
                  ) {
                    setFormErrors({
                      [editField.field]: "Invalid date-time format",
                    });
                    return;
                  }

                  // =====================
                  // REQUIRED VALIDATION
                  // =====================
                  if (String(editField?.value ?? "").trim() === "") {
                    setEditError("This field is required");
                    return;
                  }

                  setEditError("");
                  // =====================
                  // BACKEND CALL
                  // =====================
                  try {
                    await updateSingleField(
                      editField.js_id,
                      editField.field,
                      safeValue,
                    );

                    setSuccessMessage(
                      `${editField.field} updated successfully.`,
                    );
                    setTimeout(() => setSuccessMessage(""), 3000);
                    setEditField(null);
                    setFormErrors({});
                  } catch (err) {
                    // handled globally
                  }
                }}
                variant="contained"
                disabled={
                  loading || !!formErrors.start_time || !!formErrors.end_time
                }
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openDetailsDialog}
            onClose={() => {
              setOpenDetailsDialog(false);
              setSelectedJsId(null);
            }}
            fullWidth
            maxWidth="xl"
          >
            <DialogTitle
              sx={{
                fontWeight: "700",
                fontSize: "18px",
                py: 1,
              }}
            >
              Job Monitoring Details of (
              {jobs.find((job) => job.js_id === selectedJsId)?.job_name ||
                "Unknown Job"}
              )
              <IconButton
                onClick={() => {
                  setOpenDetailsDialog(false);
                  setSelectedJsId(null);
                }}
                sx={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <JobStatusDetails
                jsId={selectedJsId}
                parentDate={selectedParentDate}
                onTimesUpdate={() => {}} // Empty function to prevent error
                onParentRefresh={() =>
                  fetchPaginatedJobs(paginatedData.pagination.currentPage)
                }
              />
            </DialogContent>
          </Dialog>
          <Dialog
            open={confirmClone.open}
            onClose={() => setConfirmClone({ open: false, js_id: null })}
          >
            <DialogTitle sx={{ fontWeight: "bold" }}>Confirm Clone</DialogTitle>
             <Typography fontSize="0.9rem">
              Are you sure you want to clone this job?
            </Typography>
            <DialogActions>
              <Button
                onClick={() => setConfirmClone({ open: false, js_id: null })}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  if (confirmClone.js_id) {
                    performClone(confirmClone.js_id);
                  }
                  setConfirmClone({ open: false, js_id: null });
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openDeleteDialog}
            onClose={(event, reason) => {
              if (reason === "backdropClick") return;
              cancelDelete();
            }}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle sx={{ fontWeight: "bold" }}>
              Confirm Delete
            </DialogTitle>

            <DialogContent>
              <Typography fontSize="0.9rem">
                {(() => {
                  const selectedJob = jobs.find(
                    (job) => job.js_id === deleteJsId,
                  );
                  return (
                    <>
                      Are you sure you want to delete Job{" "}
                      <strong>
                        {selectedJob?.job_id} - {selectedJob?.job_name}
                      </strong>
                      ?
                    </>
                  );
                })()}
              </Typography>
            </DialogContent>

            <DialogActions>
              <Button onClick={cancelDelete}>Cancel</Button>

              <Button
                variant="contained"
                onClick={confirmDelete}
                disabled={loading}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </Box>
    </Container>
  );
}

export default JobMonitoring;
